import { httpService } from '~/Services/Service';

// W-0626 — Demonstrativo Financeiro / Carteira (GES > Gerencial > Relatórios > Carteira).
// Backend: RoutePrefix SEM 'api/' (deviation operador-aprovada, espelha W-0619).
// ⚠️ Consulta é GET com [FromUri] => os nomes da query string DEVEM ser camelCase
//    EXATAMENTE como a action do backend (codigoGrupoEmpresa, codigoFamilia).
//    snake_case falha silenciosamente no binding => 400 (bug sistêmico [FromUri]).

const BASE = '/relatorios/carteira/demonstrativo-financeiro';

// Monta a query string camelCase, omitindo a família quando não selecionada.
const montarQueryConsulta = (filtros) => {
  const partes = [
    `codigoGrupoEmpresa=${encodeURIComponent(filtros.codigoGrupoEmpresa)}`,
  ];

  if (
    filtros.codigoFamilia !== null &&
    filtros.codigoFamilia !== undefined &&
    filtros.codigoFamilia !== ''
  ) {
    partes.push(`codigoFamilia=${encodeURIComponent(filtros.codigoFamilia)}`);
  }

  return partes.join('&');
};

export const consultarDemonstrativoFinanceiro = (filtros) =>
  httpService.get(`${BASE}?${montarQueryConsulta(filtros)}`);

export const listarGruposEmpresaDemonstrativoFinanceiro = () =>
  httpService.get(`${BASE}/grupos-empresa`);

export const listarFamiliasDemonstrativoFinanceiro = (codigoGrupoEmpresa) =>
  httpService.get(
    `${BASE}/familias?codigoGrupoEmpresa=${encodeURIComponent(
      codigoGrupoEmpresa
    )}`
  );
